export default {
  calendarHoliday: 'تعطیلات تقویم',

  carCategory: 'خانواده خودرو',
  carType: 'نوع خودرو',
  carBrand: 'برند خودرو',
  carLoad: 'بارگیر خودرو',

  clubReferrerType: 'نوع معرف',

  cmsThemeCategory: 'دسته تم',
  cmsTheme: 'تم',

  blogPostCategory: 'دسته پست',
  blogPost: 'پست',
  blogComment: 'نظر',
  blogTag: 'تگ',

  contractCategory: 'دسته قرارداد',

  courierEquipment: 'تجهیزات پروژه',
  courierExpertise: 'حوزه کاری پروژه',

  crmFaqCategory: 'دسته سوالات متداول',
  crmCategory: 'دسته',
  crmDepartment: 'دپارتمان',
  crmMedia: 'رسانه',
  crmSubCategory: 'زیردسته',
  crmSubject: 'موضوع',
  crmContactSubject: 'موضوع تماس',

  featureCapacity: 'ظرفیت',
  featureColor: 'رنگ',
  featureSize: 'اندازه',
  featureVolume: 'حجم',

  feedbackRateCriterion: 'معیار بازخورد',

  financialBankAccount: 'حساب بانک',
  financialBank: 'بانک',
  financialPolicy: 'سیاست مالی',

  geoCity: 'شهر',
  geoCountry: 'کشور',
  geoCounty: 'شهرستان',
  geoDistrict: 'ناحیه',
  geoProvince: 'استان',
  geoTrafficPlan: 'طرح ترافیک',
  organization: 'سازمان',

  poi: 'آدرس های سراسری',
  poiCategory: 'دسته آدرس های سراسری',

  propertyEmployee: 'افراد',
  propertyItemGroup: 'گروه اقلام',
  propertyItemCategory: 'خانواده اقلام',
  propertyItemType: 'نوع اقلام',
  propertyLoad: 'نوع بار',
  propertyPackageType: 'نوع بسته‌بندی',
  propertyPackage: 'بسته',
  propertySoil: 'نوع خاک',

  questionnaireQuestionCategory: 'دسته پرسش',

  reason: 'دلایل',

  unitCurrency: 'واحد پول',
  unitMeasurement: 'واحد اندازه گیری',

  userGroup: 'گروه کاربر',
  userLevel: 'سطح کاربر',
  userEducationLevel: 'سطح تحصیلات کاربر',
  userLicenseType: 'نوع گواهینامه',

  tariffAuction: 'تعرفه مزایده',
  tariffMaterial: 'تعرفه مصالح',
  tariffFurniture: 'تعرفه اسباب‌کشی',
  tariffFurnitureCar: 'تعرفه ماشین اسباب‌کشی',
  tariffFurnitureEmployee: 'تعرفه افراد اسباب‌کشی',
  tariffFurnitureItem: 'تعرفه اقلام اسباب‌کشی',
  tariffFurnitureTrafficPlan: 'تعرفه طرح ترافیک اسباب‌کشی',
  tariffTrash: 'تعرفه نخاله',
  tariffTrashCar: 'تعرفه ماشین نخاله',
  login: 'ورود',

  securityPermission: 'سطوح دسترسی',
  securityRole: 'نقش',
  securityLimit: 'حدود اختیارات',
  securityLicensePermission: 'مجوز سطح دسترسی',
  securityLicenseLimit: 'مجوز حدود اختیارات',

  courier: 'پروژه',
  user: 'کاربر',
  address: 'آدرس',
  vehicle: 'خودرو',
  driver: 'راننده',

  order: 'بار',
  orderTemplate: 'الگو بار',
  orderDraft: 'پیش نویس بار',

  timeSheetTrafficPlan: 'جدول زمانی طرح ترافیک',
  timeSheetTrafficPlanTemplate: 'الگو جدول زمانی طرح ترافیک',
  timeSheetCourier: 'جدول زمانی پروژه',
  timeSheetCourierTemplate: 'الگو جدول زمانی پروژه',

  gatewaySms: 'درگاه پیامک',
  gatewayEmail: 'درگاه پست الکترونیکی',
  gatewayNotification: 'درگاه اطلاعیه',
  gatewayPayment: 'درگاه پرداخت',
  gatewayOrder: 'درگاه بار',
  gatewayPostage: 'درگاه مرسوله پستی',
  gatewayDelivery: 'درگاه پیک',
  gatewayPickup: 'درگاه وانت',

  bonusCouponType: 'نوع کوپن تخفیف',
  bonusGiftCardType: 'نوع کارت هدیه',
  bonusCoupon: 'کوپن تخفیف',
  bonusGiftCard: 'کارت هدیه',
  bonusCampaign: 'کمپین',
  bonusPromotion: 'پیشنهاد ویژه',

  sitePostCategory: 'دسته پست سایت‌ساز',
  siteThemeCategory: 'دسته تم سایت‌ساز',
  siteFaqCategory: 'دسته سوالات سایت‌ساز',
  sitePost: 'پست سایت‌ساز',
  siteTheme: 'تم سایت‌ساز',

  supportedOrder: 'پشتیبانی بار',
  supportedCar: 'پشتیبانی خودرو',
  supportedEmployee: 'پشتیبانی افراد',
  supportedItem: 'پشتیبانی اقلام'
}
